import { Component, Input, OnInit, AfterViewInit, trigger, state, style, transition, animate, keyframes } from "@angular/core";
import { ModalConfig } from "Classes/ModalConfig";
declare var $: any;
const ANIMATIONTIME: number = 500;

@Component({
    selector: "modal-window",
    template: require('./modal-window.component.html'),
    styles: [require('./modal-window.component.css')],
    animations: [
        trigger(
            'enterAnimation', [
                transition(':enter', [
                    style({ transform: 'translateY(-100%)', opacity: 0 }),
                    animate(ANIMATIONTIME + 'ms ease-in-out', style({ transform: 'translateY(0%)', opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ transform: 'translateY(0%)', opacity: 1 }),
                    animate(ANIMATIONTIME + 'ms ease-in-out', style({ transform: 'translateY(-100%)', opacity: 0 }))
                ])
            ]
        )
    ],
})

export class ModalWindowComponent implements OnInit, AfterViewInit {
    @Input() modalConfig: ModalConfig;

    constructor() {
    }

    ngOnInit(): void {
        this.type = this.modalConfig.type;
        this.header = this.modalConfig.headerText;
        this.body = this.modalConfig.bodyText;
        this.opened = true;
        this.focusReturn = this.modalConfig.focusReturn;
        this.okText = this.modalConfig.okText;
        this.cancelText = this.modalConfig.cancelText;
        this.footer = this.modalConfig.footer;
    }

    ngAfterViewInit(): void {
        var inputs = $(".cm-modal-window-background").find('select, input, textarea, button, a').filter(':visible');
        var firstInput = inputs.first()
        var lastInput = inputs.last().add('.cm-modal-window-background');

        /*set focus on first input*/
        firstInput.focus();

        firstInput = firstInput.add('.cm-modal-window-background');
        /*redirect last tab to first input*/
        lastInput.on('keydown', function (e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstInput.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstInput.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastInput.focus();
            }
        });
    }

    cancel(): any {
        this.opened = false;
        this.focusReturn.focus();

        setTimeout(() => {
            return this.modalConfig.cancel();
        }, ANIMATIONTIME);
    }

    ok(): any {
        this.opened = false;
        this.focusReturn.focus();
        if(this.modalConfig.ok)
            setTimeout(() => {
                return this.modalConfig.ok();
            }, ANIMATIONTIME);
    };
    header: string;
    body: string;
    type: string;
    opened: boolean = false;
    focusReturn: any;
    okText: string;
    cancelText: string;
    footer: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/modal-window.component.ts